import { fromJS } from '@gonfalon/immutable-shim/immutableShim';

import type { TimeToLoginMetricAction } from '#actions/timeToLoginMetric';
import type { GlobalState } from '#reducers/state';
import type { TimeToLoginMetric } from '#utils/loginUtils';
import { trackSignInDuration, trackSignInUIFlowComplete } from '#utils/loginUtils';

import { reducerRegistry as registry } from './registry';

export const selectTimeToLoginMetrics = (state: GlobalState) => state.timeToLoginMetric;

const initialState: TimeToLoginMetric = {
  startTime: undefined,
  endTime: undefined,
  duration: undefined,
  type: 'Password',
};
export const timeToLoginMetric = (state = fromJS(initialState), action: TimeToLoginMetricAction) => {
  switch (action.type) {
    case 'timeToLoginMetric/RESET':
      return state.set(initialState);
    case 'timeToLoginMetric/SET_START':
      return state.merge({
        startTime: action?.payload,
      });
    case 'timeToLoginMetric/SET_END':
      const duration = action?.payload - state?.get('startTime');

      const newState = state.merge({
        endTime: action?.payload,
        duration,
      });
      trackSignInUIFlowComplete(newState.get('type'));
      trackSignInDuration(newState.toJS());
      return newState;
    case 'timeToLoginMetric/SET_TYPE':
      if (state.get('type') === 'Multi-account member SSO') {
        // Since the login hook is called for both Multi-account member SSO and regular SSO, we only want to set the type once so that
        // we don't override the Multi-account member SSO type with the regular SSO type.
        return state;
      } else {
        return state.merge({
          type: action?.payload,
        });
      }

    default:
      return state;
  }
};

registry.addReducers({
  timeToLoginMetric,
});

declare module '#reducers/state' {
  interface GlobalState {
    timeToLoginMetric: ReturnType<typeof timeToLoginMetric>;
  }
}
